import update from "immutability-helper";

import {
  CE_MODAL_OPEN,
  CE_MODAL_UPDATE_STATE,
  CE_MODAL_CLOSE,
} from "@js/actions/studio/modals.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_OPEN:
      return update(state, {
        modal: { $set: { name: action.name, state: action.state } },
      });
    case CE_MODAL_UPDATE_STATE:
      return update(state, { modal: { state: { $merge: action.state } } });
    case CE_MODAL_CLOSE:
      return update(state, { modal: { $set: null } });
    default:
      return state;
  }
};
